(function () {
  var ROOT_SELECTOR = '.mr-quiz';
  var CONFIG_SELECTOR = '.mr-quiz-config';
  var CONFIG_ATTR = 'quizConfig'; // data-quiz-config
  var INIT_FLAG = 'mrQuizInitialized';

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/'/g, '&#39;');
  }

  function findConfigNode(root) {
    var sibling = root.nextElementSibling;
    if (sibling && sibling.matches(CONFIG_SELECTOR)) return sibling;

    var parent = root.parentElement;
    if (!parent) return null;

    sibling = parent.nextElementSibling;
    if (sibling && sibling.matches(CONFIG_SELECTOR)) return sibling;

    return null;
  }

  function readConfigText(node) {
    if (!node) return '';

    if (node.tagName === 'SCRIPT') {
      return node.textContent || '';
    }

    return node.textContent || node.innerText || '';
  }

  function decodeBase64Utf8(value) {
    // atob() gives a binary string; escape/decodeURIComponent restores
    // multi-byte UTF-8 characters (accents, emoji) correctly.
    return decodeURIComponent(escape(window.atob(value)));
  }

  function parseConfig(root) {
    // Preferred: inline data-quiz-config attribute (base64 JSON) on the
    // quiz root itself. Nothing readable ends up in the article's text
    // content, so it can't leak into crawled/scraped page content.
    var inlineConfig = root.dataset[CONFIG_ATTR];
    if (inlineConfig) {
      try {
        return JSON.parse(decodeBase64Utf8(inlineConfig));
      } catch (error) {
        console.warn('MRQuiz: invalid data-quiz-config on quiz root', error, root);
        return null;
      }
    }

    // Legacy fallback: adjacent ".mr-quiz-config" node with the raw JSON
    // as its text content. Kept only for articles published before the
    // data-attribute format; do not use this format for new quizzes.
    var configNode = findConfigNode(root);
    if (!configNode) {
      console.warn('MRQuiz: missing quiz config (no data-quiz-config attribute and no adjacent config node)', root);
      return null;
    }

    try {
      return JSON.parse(readConfigText(configNode));
    } catch (error) {
      console.warn('MRQuiz: invalid JSON config', error, root);
      return null;
    }
  }

  function createQuiz(root, config) {
    var state = {
      step: 'question',
      current: 0,
      answers: [],
      result: null
    };

    function push(eventName, props) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName, quiz_id: config.id }, props || {}));
    }

    function reset() {
      state.step = 'question';
      state.current = 0;
      state.answers = [];
      state.result = null;
    }

    function computeResult() {
      var scores = {};

      config.tiebreaker.forEach(function (tag) {
        scores[tag] = 0;
      });

      state.answers.forEach(function (tag) {
        if (scores[tag] !== undefined) scores[tag] += 1;
      });

      return config.tiebreaker.reduce(function (best, tag) {
        return scores[tag] > scores[best] ? tag : best;
      }, config.tiebreaker[0]);
    }

    function applyProgress(pct) {
      var bar = root.querySelector('.mrq-progress-bar');
      var fill = root.querySelector('.mrq-progress-fill');
      var ratio = Math.max(0, Math.min(1, (pct || 0) / 100));

      if (bar) {
        bar.style.setProperty('--mrq-progress', (pct || 0) + '%', 'important');
      }

      if (!fill) return;

      fill.style.setProperty('width', (pct || 0) + '%', 'important');
      fill.style.setProperty('transform', 'scaleX(' + ratio + ')', 'important');
      fill.style.setProperty('transform-origin', 'left center', 'important');
    }

    function renderHeader() {
      return (
        '<div class="mrq-header">' +
          '<h2 class="mrq-title">' + escapeHtml(config.title) + '</h2>' +
          '<div class="mrq-subtitle">' + escapeHtml(config.subtitle || '') + '</div>' +
        '</div>'
      );
    }

    function renderQuestion() {
      var question = config.questions[state.current];
      var questionNumber = state.current + 1;
      var total = config.questions.length;
      var pct = Math.round((questionNumber / total) * 100);
      var selected = state.answers[state.current] || null;
      var isLast = state.current === total - 1;
      var answersHtml = question.answers.map(function (answer) {
        var classes = 'mrq-answer' + (selected === answer.tag ? ' selected' : '');

        return (
          '<button type="button" class="' + classes + '" data-tag="' + escapeAttr(answer.tag) + '">' +
            '<span class="mrq-answer-box" aria-hidden="true"></span>' +
            '<span class="mrq-answer-label">' + escapeHtml(answer.text) + '</span>' +
          '</button>'
        );
      }).join('');
      var prevHtml = state.current > 0
        ? '<button type="button" class="mrq-btn-prev" data-action="prev">Précédent</button>'
        : '';

      root.innerHTML =
        '<div class="mrq-screen active">' +
          renderHeader() +
          '<div class="mrq-progress-label">Question ' + questionNumber + ' sur ' + total + '</div>' +
          '<div class="mrq-progress-bar"><div class="mrq-progress-fill"></div></div>' +
          '<div class="mrq-question-text">' + escapeHtml(question.text) + '</div>' +
          '<div class="mrq-answers">' + answersHtml + '</div>' +
          (prevHtml ? '<div class="mrq-nav">' + prevHtml + '</div>' : '') +
        '</div>';

      applyProgress(pct);
      window.requestAnimationFrame(function () {
        applyProgress(pct);
      });

      root.querySelectorAll('.mrq-answer').forEach(function (button) {
        button.onclick = function () {
          var tag = button.getAttribute('data-tag');
          state.answers[state.current] = tag;

          root.querySelectorAll('.mrq-answer').forEach(function (candidate) {
            candidate.classList.remove('selected');
          });

          button.classList.add('selected');
          push('quiz_question_answered', { question_number: questionNumber, answer_tag: tag });

          window.setTimeout(function () {
            if (!isLast) {
              state.current += 1;
              render();
              return;
            }

            state.result = computeResult();
            push('quiz_completed', { final_result: state.result });
            state.step = 'result';
            render();
          }, 120);
        };
      });

      var prevButton = root.querySelector('[data-action="prev"]');
      if (prevButton) {
        prevButton.onclick = function () {
          state.current -= 1;
          render();
        };
      }
    }

    function renderResult() {
      var result = config.results[state.result];
      var benefitsHtml = (result.benefits || []).map(function (benefit) {
        return '<li>' + escapeHtml(benefit) + '</li>';
      }).join('');

      root.innerHTML =
        '<div class="mrq-screen active">' +
          renderHeader() +
          '<div class="mrq-result-label">' + escapeHtml(result.label) + '</div>' +
          '<div class="mrq-result-title">' + escapeHtml(result.title) + '</div>' +
          '<div class="mrq-result-text">' + escapeHtml(result.text) + '</div>' +
          '<div class="mrq-result-context">' + escapeHtml(result.context) + '</div>' +
          '<div class="mrq-product-name">Produit recommandé&nbsp;: <strong>' + escapeHtml(result.product) + '</strong></div>' +
          '<div class="mrq-benefits">' +
            '<div class="mrq-benefits-title">Pourquoi ce produit peut vous aider</div>' +
            '<ul class="mrq-benefits-list">' + benefitsHtml + '</ul>' +
          '</div>' +
          '<a class="mrq-cta" href="' + escapeAttr(result.url) + '" data-action="cta">' + escapeHtml(result.cta) + '</a>' +
          '<button type="button" class="mrq-restart" data-action="restart">Recommencer le quiz</button>' +
        '</div>';

      push('quiz_result_viewed', { result_tag: state.result, product: result.product });

      var cta = root.querySelector('[data-action="cta"]');
      if (cta) {
        cta.onclick = function () {
          push('quiz_product_clicked', {
            result_tag: state.result,
            product: result.product,
            url: result.url
          });
        };
      }

      var restart = root.querySelector('[data-action="restart"]');
      if (restart) {
        restart.onclick = function () {
          push('quiz_restarted', { previous_result: state.result });
          reset();
          render();
        };
      }
    }

    function render() {
      if (state.step === 'question') {
        renderQuestion();
        return;
      }

      renderResult();
    }

    push('quiz_viewed');
    push('quiz_started');
    render();
  }

  function initQuiz(root) {
    if (!root || root.dataset[INIT_FLAG] === 'true') return false;

    var config = parseConfig(root);
    if (!config) return false;

    root.dataset[INIT_FLAG] = 'true';
    createQuiz(root, config);
    return true;
  }

  function initAll(scope) {
    var searchRoot = scope && scope.querySelectorAll ? scope : document;
    searchRoot.querySelectorAll(ROOT_SELECTOR).forEach(initQuiz);
  }

  window.MRQuiz = {
    init: initQuiz,
    initAll: initAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }
}());
